// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2687b70df2b21ac23348","655":"260cc31f222e5ab4039b"}[chunkId] + ".js";
};